export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.31-1341.50",
  commitId: "5bc5eb387bb62e820fb0e194259141ffff8575b9",
  commitTime: "2026-07-31T13:41:50.000Z",
});
